import { useAppSelector } from '@shared/store';

import { useAccountSelectors } from './useAccountSelectors';

export const useAccountCompanyCountry = () => {
  const selectors = useAccountSelectors();

  return useAppSelector(selectors.selectCompanyCountry);
};
